import {shareSvg as Icon__small__shareSvg} from '../Icon__small/Icon__small--share.js';

export var share = {
  name: 'share',
  category: 'icon',
  colorable: true,
  svg: Icon__small__shareSvg,
};
